import api from "./api";

export function isPushSupported() {
  return typeof navigator !== "undefined" && "serviceWorker" in navigator &&
    "PushManager" in window && "Notification" in window;
}

function urlB64ToUint8Array(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const base = (b64 + pad).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function registerSW() {
  if (!("serviceWorker" in navigator)) return null;
  try { return await navigator.serviceWorker.register("/sw.js"); }
  catch (e) { return null; }
}

export async function getPushState() {
  if (!isPushSupported()) return { supported: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, permission: Notification.permission, subscribed: !!sub };
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Notifications aren't supported on this browser.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { permission: perm, subscribed: false };
  const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.enabled || !data.public_key) throw new Error("Push isn't configured on the server.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.public_key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return { permission: "granted", subscribed: true };
}

export async function unsubscribeFromPush() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch (e) { /* ignore */ }
    try { await sub.unsubscribe(); } catch (e) { /* ignore */ }
  }
}
